// BSN-validatie met de 11-proef. Spiegelt utils/bsn.ts op de server; die
// blijft de bron van waarheid, dit is alleen om de klant direct te helpen.
export const normaliseerBsn = (waarde) => String(waarde ?? "").replace(/\D/g, "");

export const isGeldigBsn = (waarde) => {
  const cijfers = normaliseerBsn(waarde);
  if (cijfers.length !== 8 && cijfers.length !== 9) return false;
  const bsn = cijfers.padStart(9, "0");
  if (/^0+$/.test(bsn)) return false;
  let som = 0;
  for (let i = 0; i < 9; i += 1) {
    const cijfer = Number(bsn[i]);
    som += i === 8 ? -cijfer : cijfer * (9 - i);
  }
  return som % 11 === 0;
};

// De KvK kent geen RSIN voor een eenmanszaak; dan hebben wij het BSN van de
// eigenaar nodig om de aanvraag te kunnen indienen.
export const isEenmanszaak = (...rechtsvormen) =>
  rechtsvormen.some((r) => /eenmanszaak/i.test(String(r ?? "")));
